import { useEffect, useState } from 'react';

/** No shared debounce hook exists in the app yet (checked); this one is
 *  small enough to own locally rather than add a new cross-app primitive for
 *  two call sites (the "Tạo mới" tab's per-row duplicate lookup and "Chọn từ
 *  danh sách"'s search box). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
